import React, { TextareaHTMLAttributes } from "react";

const TextareaControl: React.FC<TextareaHTMLAttributes<HTMLTextAreaElement>> = (
  props
) => {
  return (
    <div className="flex flex-col gap-2 items-start">
      <label htmlFor={props.id} className="font-medium capitalize text-lg">
        {props.name}
      </label>
      <textarea
        {...props}
        className={`bg-transparent px-2 py-1 secondary-outline border primary-border-color rounded-lg w-full resize-none ${props.className}`}>
        {props.children}
      </textarea>
    </div>
  );
};

export default TextareaControl;
